const loanChannelConfiguration = {
  1: "Banked - Retail",
  2: "Banked - Wholesale",
  3: "Brokered",
  4: "Correspondent"
};
export {
  loanChannelConfiguration
};
